import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { ConfiguracaoMedico, ConfiguracaoConviteSecretaria, ConfiguracaoLocalAtendimento, TipoConviteEnum, Medico } from '@/types/_'

@Module({ namespaced: true, name: 'ConfiguracaoNotificacoesStore' })
export default class ConfiguracaoNotificacoesStore extends VuexModule {
  private conviteSecretariaDefault: ConfiguracaoConviteSecretaria = {
    secretariaId: '',
    cpf: '',
    email: '',
    nome: '',
    assinarEnviar: true,
    medicoId: '',
    localAtendimentoId: '',
    tipo: TipoConviteEnum.SecretariaAgendamento,
    nomeMedico: '',
    localAtendimentoNome: '',
  }

  private locaisAtendimentosDefault: ConfiguracaoLocalAtendimento[] = []
  private localAtendimentoDefault: ConfiguracaoLocalAtendimento = {
    id: '',
    nome: '',
    secretarias: [],
    emailsNotificacao: [],
    ambulatorio: null,
  }

  public locaisAtendimentos: ConfiguracaoLocalAtendimento[] = [...this.locaisAtendimentosDefault]
  public localAtendimento: ConfiguracaoLocalAtendimento = { ...this.localAtendimentoDefault }
  public conviteSecretaria: ConfiguracaoConviteSecretaria = { ...this.conviteSecretariaDefault }
  public configuracaoNotificacoes: ConfiguracaoMedico[] = []

  private assinaturaMedicoDefault: string = ''
  public assinaturaMedico: string = this.assinaturaMedicoDefault
  public medicos: Medico[] = []

  private medicoSelecionadoDefault: Medico = {
    id: '',
    nome: '',
    urlAssinatura: '',
  }

  public medicoSelecionado: Medico = { ...this.medicoSelecionadoDefault }
  public locaisAtendimentoHospitalSelecionado: any[] = []
  public locaisAtendimentoClinicaSelecionado: any[] = []
  public locaisAtendimentosHospital: any[] = []
  public locaisAtendimentosClinica: any[] = []
  public secretaria: any = {}

  @Mutation
  setMedicoSelecionado(medico: Medico) {
    this.medicoSelecionado = medico
  }

  @Mutation
  setLocaisAtendimentoHospitalSelecionado(value: any[]) {
    this.locaisAtendimentoHospitalSelecionado = value
  }

  @Mutation
  setLocaisAtendimentoClinicaSelecionado(value: any[]) {
    this.locaisAtendimentoClinicaSelecionado = value
  }

  @Mutation
  clearLocaisAtendimento() {
    this.medicoSelecionado = { ...this.medicoSelecionadoDefault }
    this.medicos = []
    this.locaisAtendimentosHospital = []
    this.locaisAtendimentosClinica = []
  }

  @Mutation
  clearLocaisAtendimentoHospitalSelecionado() {
    this.locaisAtendimentoHospitalSelecionado = []
  }

  @Mutation
  clearLocaisAtendimentoClinicaSelecionado() {
    this.locaisAtendimentoClinicaSelecionado = []
  }

  @Mutation
  setAssinaturaMedico(value: string) {
    this.assinaturaMedico = value
  }

  @Mutation
  clearAssinaturaMedico() {
    this.assinaturaMedico = this.assinaturaMedicoDefault
  }

  @Mutation
  setLocaisAtendimentos(value: ConfiguracaoLocalAtendimento[]) {
    this.locaisAtendimentos = value
  }

  @Mutation
  setLocalAtendimento(value: ConfiguracaoLocalAtendimento) {
    this.localAtendimento = value
  }

  @Mutation
  clearLocaisAtendimentos() {
    this.locaisAtendimentos = [...this.locaisAtendimentosDefault]
  }

  @Mutation
  clearLocalAtendimento() {
    this.localAtendimento = { ...this.localAtendimentoDefault }
  }

  @Mutation
  addEmail(params: any) {
    this.configuracaoNotificacoes.map((configuracao: any) => {
      if (configuracao.id === params.medicoId) {
        configuracao.locaisAtendimento.map((local: any) => {
          if (local.id === params.localAtendimentoId) {
            local.emailsNotificacao.push(params.email)
          }
          return local
        })
      }
      return configuracao
    })
  }

  @Mutation
  setConfiguracoesNotificacoes(values: ConfiguracaoMedico[]) {
    this.configuracaoNotificacoes = []
    values.map((c) => {
      let locais = []
      if (c.locaisAtendimento) {
        // @ts-ignore
        locais = c.locaisAtendimento.map((local: any) => {
          if (!local.emailsNotificacao) return { ...local, emailsNotificacao: [] }
          if (!local.secretarias) return { ...local, secretarias: [] }
          return local
        })
      }

      const t: ConfiguracaoMedico = {
        id: c.id,
        nome: c.nome,
        email: c.email.includes(';') ? c.email.split(';')[0] : c.email,
        celular: c.celular,
        celularOriginal: c.celular,
        loading: false,
        notificacaoUsuario: c.notificacaoUsuario,
        locaisAtendimento: locais,
        recebeEmailNotificacao: c.recebeEmailNotificacao,
        medicoTemUsuario: c.medicoTemUsuario,
        recebeNotificacaoViaWhatsApp: c.recebeNotificacaoViaWhatsApp,
      }

      this.configuracaoNotificacoes.push(t)
      return c
    })
  }

  @Mutation
  setDeletarSecretaria(params: any) {
    this.configuracaoNotificacoes.map((configuracao: any) => {
      if (configuracao.id === params.medicoId) {
        configuracao.locaisAtendimento.map((local: any) => {
          if (local.id === params.localAtendimentoId) {
            const indexSecretaria = local.secretarias.findIndex((e: any) => e.id === params.secretariaId)
            local.secretarias.splice(indexSecretaria, 1)
          }
          return local
        })
      }
      return configuracao
    })
  }

  @Mutation
  setSecretariaExistente(params: any) {
    this.conviteSecretaria.secretariaId = params.id
    this.conviteSecretaria.nome = params.nome
  }

  @Mutation
  setDeletarEmail(params: any) {
    this.configuracaoNotificacoes.map((configuracao: any) => {
      if (configuracao.id === params.medicoId) {
        configuracao.locaisAtendimento.map((local: any) => {
          if (local.id === params.localAtendimentoId) {
            const indexEmail = local.emailsNotificacao.findIndex((e: any) => e === params.email)
            local.emailsNotificacao.splice(indexEmail, 1)
          }
          return local
        })
      }
      return configuracao
    })
  }

  @Mutation
  clearConviteSecretaria() {
    this.conviteSecretaria = { ...this.conviteSecretariaDefault }
  }

  @Mutation
  setNovoLocalAtendimento(params: any) {
    this.configuracaoNotificacoes.map((configuracao: any) => {
      if (configuracao.id === params.medicoId) {
        configuracao.locaisAtendimento.push({
          id: params.localAtendimentoId,
          nome: params.LocalAtendimentoNome,
          emailsNotificacao: [],
          secretarias: [],
        })
      }
      return configuracao
    })
  }

  @Mutation
  deletarLocalAtendimento(params: any) {
    this.configuracaoNotificacoes.map((configuracao: any) => {
      if (configuracao.id === params.medicoId) {
        const indexLocalAtendimento = configuracao.locaisAtendimento.findIndex((e: any) => e.id === params.localAtendimentoId)
        configuracao.locaisAtendimento.splice(indexLocalAtendimento, 1)
      }
      return configuracao
    })
  }

  @Mutation
  setMedicoRecebeEmailNotificacao(params: any) {
    const novaConfiguracao: ConfiguracaoMedico[] = this.configuracaoNotificacoes.map((configuracao: any) => {
      const conf = { ...configuracao }
      if (conf.id === params.id) {
        conf.recebeEmailNotificacao = params.recebeEmailNotificacao
      }
      return conf
    })
    this.configuracaoNotificacoes = novaConfiguracao
  }

  @Mutation
  setMedicoRecebeWhatsappNotificacao(params: any) {
    const novaConfiguracao: ConfiguracaoMedico[] = this.configuracaoNotificacoes.map((configuracao: any) => {
      const conf = { ...configuracao }
      if (conf.id === params.id) {
        conf.recebeWhatsappNotificacao = params.recebeWhatsappNotificacao
      }
      return conf
    })
    this.configuracaoNotificacoes = novaConfiguracao
  }

  @Mutation
  setMedicos(values: Medico[]) {
    this.medicos = values
  }

  @Mutation
  setLocaisAtendimentosHospital(values: any[]) {
    if (values.length > 0) {
      this.locaisAtendimentosHospital = values.map((c) => {
        if (c.isMedicoAtendeLocal) this.locaisAtendimentoHospitalSelecionado.push(c.id)
        return c
      })
    } else {
      this.locaisAtendimentosHospital = []
    }
  }

  @Mutation
  setLocaisAtendimentosClinica(values: any[]) {
    if (values.length > 0) {
      this.locaisAtendimentosClinica = values.map((c) => {
        if (c.isMedicoAtendeLocal) this.locaisAtendimentoClinicaSelecionado.push(c.id)
        return c
      })
    } else {
      this.locaisAtendimentosClinica = []
    }
  }

  @Mutation
  removeLocalAtendimentoHospital(value: any) {
    const index = this.locaisAtendimentoHospitalSelecionado.indexOf(value)
    if (index >= 0) this.locaisAtendimentoHospitalSelecionado.splice(index, 1)
  }

  @Mutation
  removeLocalAtendimentoClinica(value: any) {
    const index = this.locaisAtendimentoClinicaSelecionado.indexOf(value)
    if (index >= 0) this.locaisAtendimentoClinicaSelecionado.splice(index, 1)
  }

  @Mutation
  setSecretaria(value: any) {
    this.secretaria = value
  }

  @Action
  async getMedicos() {
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getMedicoshospitalByUserCurrent()

    if (request.success) {
      this.context.commit('setMedicos', request.data)
    }

    return request
  }

  @Action
  async getSecretariaInfo() {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getSecretariaInfo()
    if (response.success) {
      this.context.commit('setSecretaria', response.data)
    }
    return response
  }

  @Action
  async associarMedicoLocaisAtendimento() {
    const params: any = {
      medicoId: this.medicoSelecionado,
      LocaisAtendimento: this.locaisAtendimentoHospitalSelecionado,
    }

    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.associarMedicoLocaisAtendimento(params)

    return response
  }

  @Action
  async associarMedicoLocaisAtendimentoClinica() {
    const params: any = {
      medicoId: this.medicoSelecionado,
      LocaisAtendimento: this.locaisAtendimentoClinicaSelecionado,
    }

    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.associarMedicoLocaisAtendimentoClinica(params)

    return response
  }

  @Action
  async getLocaisAtendimentoHospitalByMedicoId() {
    const params: any = { medicoId: this.medicoSelecionado }
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getLocaisAtendimentoHospitalByMedicoId(params)

    if (request.success) {
      this.context.commit('setLocaisAtendimentosHospital', request.data)
    }

    return request
  }

  @Action
  async getLocaisAtendimentoClinicaByMedicoId() {
    const params: any = { medicoId: this.medicoSelecionado }
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getLocaisAtendimentoClinicaByMedicoId(params)

    if (request.success) {
      this.context.commit('setLocaisAtendimentosClinica', request.data)
    }

    return request
  }

  @Action
  async getConfiguracoes() {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getConfiguracoes()
    if (response.success) {
      this.context.commit('setConfiguracoesNotificacoes', response.data.medicos)
    }
    return this.configuracaoNotificacoes
  }

  @Action
  async getAssinaturaDoMedico() {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAssinaturaDoMedico()
    if (response.success) {
      this.context.commit('setAssinaturaMedico', `data:image/png;base64,${response.data}`)
    }
    return response
  }

  @Action
  async updateAssinaturaDoMedico(params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.updateAssinaturaDoMedico(params)
    if (response.success) {
      this.context.commit('setAssinaturaMedico', `data:image/png;base64,${params.assinatura}`)
    }
    return response
  }


  @Action
  async medicoRecebeNotificacaoEmailPessoal(params: ConfiguracaoMedico) {
    const { id, recebeEmailNotificacao } = params
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.medicoRecebeNotificacaoEmailPessoal(params)
    this.context.commit('setMedicoRecebeEmailNotificacao', { id, recebeEmailNotificacao })
    return request
  }

  @Action
  async medicoRecebeNotificacaoWhatsappPessoal(params: ConfiguracaoMedico) {
    const { id, recebeNotificacaoViaWhatsApp } = params
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.medicoRecebeNotificacaoWhatsappPessoal(params)
    this.context.commit('setMedicoRecebeWhatsappNotificacao', { id, recebeNotificacaoViaWhatsApp })
    return request
  }

  @Action
  async alteraDadosNotificacao(params: Partial<ConfiguracaoMedico>) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.alteraDadosNotificacao(params)
    return request
  }

  @Action
  async adicionarEmail(params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.adicionarEmail(params)

    if (response.success) {
      this.context.commit('addEmail', params)
    }

    return response
  }

  @Action
  async sendConvite() {
    const conviteSecretaria: any = {
      cpf: this.conviteSecretaria.cpf,
      email: this.conviteSecretaria.email,
      nome: this.conviteSecretaria.nome,
      tipo: TipoConviteEnum.SecretariaAgendamento,
      assinarEnviar: true,
      medicoId: this.conviteSecretaria.medicoId,
      localAtendimentoId: this.conviteSecretaria.localAtendimentoId,
      localAtendimentoNome: this.conviteSecretaria.localAtendimentoNome,
    }

    const response = await Apis.Cadastro.CadastroApi.sendConvite(conviteSecretaria)
    return response
  }

  @Action
  async associarContaSecretaria() {
    const conviteSecretaria: any = {
      cpf: this.conviteSecretaria.cpf,
      localAtendimentoId: this.conviteSecretaria.localAtendimentoId,
      medicoId: this.conviteSecretaria.medicoId,
    }

    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.associarContaSecretaria(conviteSecretaria)
    return response
  }

  @Action
  async deletarSecretaria(params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.deletarSecretaria(params)

    if (response.success) {
      this.context.commit('setDeletarSecretaria', params)
    }

    return response
  }

  @Action
  async deletarEmail(params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.deletarEmail(params)

    if (response.success) {
      this.context.commit('setDeletarEmail', params)
    }

    return response
  }

  @Action
  async atualizaSecretariaVisualizaSolicitacoesAmbulatorio(params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.atualizaSecretariaVisualizaSolicitacoesAmbulatorio(params)
    return response
  }

  @Action
  async adicionaMedicoLocalAtendimento(params: any) {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.adicionaMedicoLocalAtendimento(params)
    if (response.success) {
      this.context.commit('setNovoLocalAtendimento', { ...params, localAtendimentoId: response.data })
    }
    return response
  }

  @Action
  async removeMedicoLocalAtendimento(params: any) {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.removeMedicoLocalAtendimento(params)
    if (response.success) {
      this.context.commit('deletarLocalAtendimento', params)
    }
    return response
  }
}
